import React from 'react';
import Navbar from '../../components/Navbar';

const Header = (props) => {
  return (
    <div>
      <Navbar />
    </div>
  );
};

export default Header;
